import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import { Table, Button, Container, Row, Col, Card, Modal } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import './ManageSubscriptionplans.css';
import BaseUrl from '../../ApiServices/BaseUrl';

function ManageSubscriptionplans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/api/subscriptionplans`);
      setPlans(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleAddPlan = () => {
    navigate('/subscriptionform');
  };

  const handleEditPlan = (id) => {
    navigate(`/subscriptionform/${id}`);
  };

  const handleViewPlan = async (id) => {
    try {
      const response = await axios.get(`${BaseUrl}/api/subscriptionplans/${id}`);
      setSelectedPlan(response.data);
      setShowViewModal(true);
    } catch (err) {
      Swal.fire(
        'Error!',
        'Failed to load plan details',
        'error'
      );
    }
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setSelectedPlan(null);
  };

  const confirmDelete = (plan) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to delete the "${plan.plan_name}" plan`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${BaseUrl}/api/subscriptionplans/${plan.id}`);

          Swal.fire(
            'Deleted!',
            'The subscription plan has been deleted.',
            'success'
          );

          fetchPlans(); // Refresh the list after deletion
        } catch (err) {
          Swal.fire(
            'Error!',
            err.response?.data?.error || 'Failed to delete plan',
            'error'
          );
        }
      }
    });
  };

  const showSuccessAlert = (message) => {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 1500
    });
  };

  if (loading) return <div className="text-center mt-5">Loading...</div>;
  if (error) return <div className="text-center mt-5 text-danger">Error: {error}</div>;

  return (
    <>
      <AdminNavbar />
      <Container className="" style={{ marginTop: '80px' }}>
        <Row className="mb-4 flex-row">
          <Col className="text-center text-md-start mb-2 mb-md-0">
            <h2>Manage Subscription Plans</h2>
          </Col>
          <Col className="text-center text-md-end">
            <Button variant="primary" className='managesubscriptionplans-add' onClick={handleAddPlan}>
              Add Plan
            </Button>
          </Col>
        </Row>

        <div className='managesubscriptionplans-card'>
          <Card>
            <Card.Body>
              <div className="subscription-table-container">
                <div className="subscription-table-scroll">
                  <Table striped bordered hover className="subscription-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Plan Name</th>
                        <th>Duration</th>
                        <th>Access Type</th>
                        <th>Job Position</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {plans.map((plan, index) => (
                        <tr key={plan.id}>
                          <td>{index + 1}</td>
                          <td>{plan.plan_name}</td>
                          <td>{plan.listing_duration_days}</td>
                          <td>{plan.access_type}</td>
                          <td>{plan.job_position_priority}</td>
                          <td>
                            <div className="managesubscriptionsplans-buttons">
                              <Button variant="primary" size="sm" onClick={() => handleViewPlan(plan.id)}>View</Button>
                              <Button variant="primary" size="sm" onClick={() => handleEditPlan(plan.id)}>Edit</Button>
                              {/* <Button variant="danger" size="sm" onClick={() => confirmDelete(plan)}>Delete</Button> */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        {/* View Plan Details Modal */}
        <Modal show={showViewModal} onHide={closeViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Subscription Plan Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedPlan && (
              <Card>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong>Plan ID:</strong>
                        <p className="text-muted">{selectedPlan.id}</p>
                      </div>
                      <div className="mb-3">
                        <strong>Plan Name:</strong>
                        <p className="text-muted">{selectedPlan.plan_name}</p>
                      </div>
                      <div className="mb-3">
                        <strong>Duration:</strong>
                        <p className="text-muted">{selectedPlan.listing_duration_days}</p>
                      </div>
                      <div className="mb-3">
                        <strong>Access Type:</strong>
                        <p className="text-muted">{selectedPlan.access_type}</p>
                      </div>
                      <div className="mb-3">
                        <strong>Job Position Priority:</strong>
                        <p className="text-muted">{selectedPlan.job_position_priority}</p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong>Messaging Limit:</strong>
                        <p className="text-muted">{selectedPlan.messaging_limit}</p>
                      </div>
                      <div className="mb-3">
                        <strong>WhatsApp Access:</strong>
                        <p className="text-muted">{selectedPlan.whatsapp_access}</p>
                      </div>
                      <div className="mb-3">
                        <strong>Direct Call Access:</strong>
                        <p className="text-muted">{selectedPlan.direct_call_access}</p>
                      </div>
                      <div className="mb-3">
                        <strong>Share Option:</strong>
                        <p className="text-muted">{selectedPlan.share_option}</p>
                      </div>
                      <div className="mb-3">
                        <strong>View Limit:</strong>
                        <p className="text-muted">{selectedPlan.view_limit}</p>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong>Alerts for New CVs:</strong>
                        <p className="text-muted">
                          {selectedPlan.alerts_for_new_cvs ? 'Yes' : 'No'}
                        </p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong>Full Contact Details:</strong>
                        <p className="text-muted">
                          {selectedPlan.full_contact_details ? 'Yes' : 'No'}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong>Activate/Deactivate Option:</strong>
                        <p className="text-muted">
                          {selectedPlan.activate_deactivate_option ? 'Yes' : 'No'}
                        </p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong>Created At:</strong>
                        <p className="text-muted">
                          {new Date(selectedPlan.created_at).toLocaleDateString()}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  {selectedPlan.description && (
                    <Row>
                      <Col>
                        <div className="mb-3">
                          <strong>Description:</strong>
                          <div
                            style={{
                              maxHeight: '150px',
                              overflowY: 'auto',
                              backgroundColor: '#f8f9fa',
                              padding: '10px',
                              borderRadius: '0px',
                              border: '1px solid #dee2e6',
                              marginTop: '5px'
                            }}
                          >
                            <p className="text-muted mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                              {selectedPlan.description}
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeViewModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
}

export default ManageSubscriptionplans;

